const AFFILIATE_TAG = 'ygkp-20';

export interface AffiliateProduct {
  name: string;
  desc: string;
  query: string;
  icon: string;
}

// Search-based links never 404 (unlike fixed ASIN /dp/ links) and still carry the tag.
export const AFFILIATE_PRODUCTS: AffiliateProduct[] = [
  { name: 'Monitor Color Calibrator', desc: 'Nail color accuracy on any display', query: 'monitor color calibrator', icon: '🎨' },
  { name: 'Monitor Arm Mount', desc: 'Ergonomic adjustable desk mount', query: 'monitor arm desk mount', icon: '🦾' },
  { name: 'IPS Office Monitor', desc: 'High refresh-rate IPS panel for work', query: 'ips panel high refresh rate monitor', icon: '🖥️' },
  { name: 'Screen Cleaning Kit', desc: 'Safe for OLED & LCD coatings', query: 'screen cleaning kit electronics', icon: '🧴' },
];

export function amazonSearchUrl(query: string): string {
  return `https://www.amazon.com/s?k=${encodeURIComponent(query)}&tag=${AFFILIATE_TAG}`;
}

interface AffiliateAdProps {
  isCollapsed: boolean;
}

export function AffiliateAd({ isCollapsed }: AffiliateAdProps) {
  // Fixed order: calibrator first, then arm, IPS monitor, cleaning kit.
  const items = AFFILIATE_PRODUCTS;

  if (isCollapsed) return null;

  return (
    <div>
      <p className="text-[9px] font-bold uppercase tracking-[0.2em] text-gray-600 mb-2 px-3">
        Sponsored
      </p>
      <div className="space-y-1.5">
        {items.map((p) => (
          <a
            key={p.query}
            href={amazonSearchUrl(p.query)}
            target="_blank"
            rel="noopener noreferrer sponsored"
            className="flex items-center gap-2.5 p-2 rounded-xl bg-[#141414] border border-[#1e1e1e] hover:border-[#00d9ff]/30 hover:bg-[#1a1a1a] transition-all duration-200 group"
          >
            <span className="text-lg flex-shrink-0">{p.icon}</span>
            <div className="min-w-0 flex-1">
              <p className="text-[11px] font-medium text-gray-300 group-hover:text-white transition-colors leading-snug truncate">
                {p.name}
              </p>
              <p className="text-[10px] text-gray-600 leading-snug truncate">{p.desc}</p>
            </div>
            <span className="text-[11px] text-[#00d9ff]/50 group-hover:text-[#00d9ff] transition-colors flex-shrink-0">
              →
            </span>
          </a>
        ))}
      </div>
    </div>
  );
}
